import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  Modal,
  DropdownButton,
  MenuItem,
  ButtonGroup
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  delete_review,
  get_review_list_for_admin,
  change_review_status
} from "../../../redux/actions/reviewActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import StarRatingComponent from "react-star-rating-component";
import {aclUtil} from "../../util"
import ReactHtmlParser from 'react-html-parser';

const history = createBrowserHistory();
class OfferReviewList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'MANAGE_REVIEWS',
      offerReviewList: [],
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "",
      path: ["Home", "Review List"],
      links: ["home",'offerReviews'],
      show: false,
      ratingSortIcon: "",
      direction: "",
      orderBy: "",
      searchString: "",
      review: "",
      showModal: false,
      name: "",
      firstNameSortIcon: "",
      created_onSortIcon: "",
      dealTextSortIcon: ""
    };
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.get_review_list_for_admin({
      page: this.state.currentPage,
      orderBy: orderBy,
      direction: direction,
      limit: this.state.limit
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  handleShowReview = (review, firstName, lastName) => e => {
    const name = `${firstName} ${lastName}`;
    this.setState({ review: review, name: name, showModal: true });
  };

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    this.props.get_review_list_for_admin({ page: this.state.currentPage, limit: this.state.limit });
  }
  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.get_review_list_for_admin({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit
      });
    } else if (this.state.searchString !== "") {
      this.props.get_review_list_for_admin({
        page: page,
        search: this.state.searchString,
        limit: this.state.limit
      });
    } else {
      this.props.get_review_list_for_admin({ page: page, limit: this.state.limit });
    }
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    if (searchString.length > 0) {
      this.props.get_review_list_for_admin({ search: searchString });
    } else {
      this.props.get_review_list_for_admin({ page: this.state.currentPage, limit: this.state.limit });
    }
    this.setState({ searchString: searchString });
  };

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.reviewListForAdmin !== nextProps.reviewListForAdmin) {
      if (nextProps.reviewListForAdmin) {
        const setPageCount =
          nextProps.reviewListForAdmin.total /
          nextProps.reviewListForAdmin.per_page;
        this.setState({
          offerReviewList: nextProps.reviewListForAdmin.data,
          totalRecords: nextProps.reviewListForAdmin.total,
          perPage: nextProps.reviewListForAdmin.per_page,
          pageCount: setPageCount
        });
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({ alertMessage: nextProps.message });
    }
    if (nextProps.alertType) {
      this.setState({ msgType: nextProps.alertType });
    }

    if (this.props.statusResponse !== nextProps.statusResponse) {
      if (nextProps.statusResponse.message) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.statusResponse.message);
        this.props.get_review_list_for_admin({ page: this.state.currentPage, limit: this.state.limit });
      }
    }

    if (this.props.deleteReviewResponse !== nextProps.deleteReviewResponse) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.deleteReviewResponse.message);
      this.props.get_review_list_for_admin({ page: this.state.currentPage, limit: this.state.limit });
    }
  }

  handleDelete = reviewID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(reviewID);
        })
      ]
    });
  };

  handleChangeStatus = reviewID => e => {
    this.props.change_review_status({
      reviewID: reviewID,
      status: e.target.value
    });
  };

  confirmDelete = reviewID => {
    this.props.delete_review(reviewID);
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let reviewRow;
    if (
      !isEmpty(this.props.reviewListForAdmin) &&
      this.props.reviewListForAdmin.data.length > 0
    ) {
      reviewRow = this.props.reviewListForAdmin.data.map((review, index) => (
        <tr key={review.reviewID}>
          <td>{review.created_on}</td>
          <td>{ReactHtmlParser(review.dealText)}</td>
          <td>{`${review.firstName} ${review.userLastName}`}</td>
          <td
            onClick={this.handleShowReview(
              review.review,
              review.firstName,
              review.userLastName
            )}
          >
            {review.review.length > 30
              ? `${review.review.substr(0, 30)}...`
              : review.review}
          </td>
          <td>
            <StarRatingComponent
              name="rate1"
              editing={false}
              starCount={5}
              value={parseInt(review.rating)}
            />
          </td>
          <td>
            <FormGroup controlId={`formControlsSelect${review.reviewID}`}>
              <FormControl
                componentClass="select"
                placeholder="Status"
                name="status"
                value={review.status}
                onChange={this.handleChangeStatus(review.reviewID)}
              >
                <option value="public">Public</option>
                <option value="private">Private</option>
                <option value="notapproved">Not Approved</option>
              </FormControl>
            </FormGroup>
          </td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_REVIEW') ? (<MenuItem eventKey={Math.random()} onClick={() =>  this.context.router.history.push(`/editOfferReview/${review.reviewID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit Review</MenuItem>):("")}
                  {aclUtil.checkACL('DELETE_REVIEW') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, review.reviewID)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 review-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Review List</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType.toLowerCase()}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" onKeyUp={this.handleSearch()} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th onClick={this.handleSort("created_on")}>
                        Created On<span
                          className={this.state.created_onSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("dealText")}>
                        Deal Name<span
                          className={this.state.dealTextSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("firstName")}>
                        User Name<span
                          className={this.state.firstNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>Review</th>
                      <th onClick={this.handleSort("rating")}>
                        Rating<span
                          className={this.state.ratingSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>{reviewRow}</tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title
              style={{ textTransform: "capitalize", fontWeight: "bold" }}
            >
              {this.state.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                {" "}
                Review:{" "}
              </span>
            </div>
            <p>
              {this.state.review.charAt(0).toUpperCase() +
                this.state.review.substr(1)}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleCloseModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

OfferReviewList.propTypes = {
  get_review_list_for_admin: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  reviewListForAdmin: state.reviewReducer.reviewListForAdmin,
  error: state.reviewReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  statusResponse: state.reviewReducer.statusResponse,
  deleteReviewResponse: state.reviewReducer.deleteReviewResponse
});

export default withRouter(connect(mapStateToProps, {
  delete_review,
  change_review_status,
  get_review_list_for_admin,
  renderAlert,
  clearAlert
})(OfferReviewList));



// WEBPACK FOOTER //
// ./src/app/views/admin/offerReview/OfferReviewList.js